import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f561c3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { style: {"text-align":"right","margin-right":"30px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = { class: "warp-left" }
const _hoisted_10 = { class: "warp-conen" }
const _hoisted_11 = { class: "warp-right" }
const _hoisted_12 = { class: "carousel" }

import { h, onMounted, reactive, ref, VNode,nextTick } from "vue";
import { message, TreeProps } from "ant-design-vue";
import UploadImage from "@/components/view/UploadImage.vue";
import {
    addPosition,
    addPositionStaff,
    deletePositionStaff,
    getPosition,
    getPositionStaff,
    searchPositionStaff,
    updatePositionStaff,
} from "@/api/organization";
import { useRoute } from "vue-router";
import dayjs, { Dayjs } from "dayjs";
import { getDate } from "@/components/ts/components";
import STATUS from "@/components/model/enum";
import { Rule } from "ant-design-vue/lib/form";
import { cardid, isEmail, isMobile } from "@/utils/validate";
import { searchTeamMembers } from "@/api/dentist_team";
import DentistForm from "@/views/doctor/AddDoctor.vue";
import { pageMembers as pageMembersProducer } from "@/api/producer";
import { pageMembers as pageMembersDesigner } from "@/api/designer";
import DesignerForm from "@/views/designer/designerForm.vue";
import ProductForm from "@/views/producer/productForm.vue";
// import DoctorDetail from "@/views/doctor/DoctorDetail.vue";
import DoctorView from "@/views/doctor/DoctorView.vue";
import { getDentistInfo, reviewDentist } from "@/api/doctor";
import { copyToClip } from "@/utils/clip";
import mobileView from "@/components/view/mobileView.vue";
// import { on } from "events";
import {searchSysRole} from "@/api/role";

interface Data {
    //通用属性
    dataSource: any[],
    columns: any[],
    positionVisible: boolean,
    staffVisible: boolean,
    positionFormState: any,
    staffFormState: any,
    staffType: string,
    selectedKey: string,
    avatarUrl: string,
    partnerId: string | undefined | any,
    staffTitle: string,
    treeData: any[],
    loading: boolean,
    pagination: any,
    searchMobile: string,
    searchName: string,
    roleOption: any[],
    //医生团队
    dentistTeamId: string | undefined | any,
    dentistId: string | undefined | any,
    dentistOpType: string,
    dentist_form_visible: boolean
    //设计师团队
    designerTeamId: string | undefined | any,
    designerId: string | undefined | any,
    designerOpType: string,
    designer_form_visible: boolean
    //工厂团队
    productTeamId: string | undefined | any,
    producerId: string | undefined | any,
    productOpType: string,
    product_form_visible: boolean
    //医生审核
    dentist_detail_form_visible: boolean,
    dentist_review_common: string;
    doctorInfo: {
        id: string,
        name: string;
        email: string;
        mobile: string;
        gender: string;
        born: string;
        idNumber: string;
        level: string,
        license: string,
        docs: any[]
    },
    inputStatus: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Department',
  setup(__props) {

const fieldNames: TreeProps["fieldNames"] = {
    children: "children",
    title: "name",
    key: "id",
};
const data = reactive<Data>({
    dataSource: [],
    columns: [
        {
            title: "姓名",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "生日",
            dataIndex: "born",
            key: "born",
        },
        {
            title: "手机号",
            dataIndex: "mobile",
            key: "mobile",
            width: 130,
            customRender: function ({ record }: any): VNode {
                return h(mobileView,
                    {
                        mobile: record.mobile,
                        title: '点击复制',
                        onClick: () => copyToClip(record.mobile),
                    },
                    ()=>record.mobile)
            },
        },
        {
            title: "性别",
            dataIndex: "gender",
            key: "gender",
        },
        {
            title: "负责人",
            dataIndex: "deptLeader",
            key: "deptLeader",
        },
        {
            title: "职位",
            dataIndex: "positionName",
            key: "positionName",
        },
        {
            title: "审核状态",
            dataIndex: "reviewStatus",
            key: "reviewStatus",
        },
        {
            title: "操作",
            dataIndex: "operation",
            key: "operation",
        },
    ],
    positionVisible: false,
    staffVisible: false,
    positionFormState: {
        name: "",
        comment: "",
        treeValue: 0,
        id: ''
    },
    staffFormState: {
        person: {
            name: "",
            email: "",
            mobile: "",
            gender: "Male",
            born: "",
            idNumber: "",
            owner: "",
            id: null,
        },
        docs: [
            {
                id: null,
                type: "AVATAR",
                path: "",
            },
        ],
        deptLeader: false,
        positionId: "",
        id: "",
        roleIds: [],
    },
    treeData: [],
    selectedKey: "",
    avatarUrl: "",
    partnerId: "",
    staffTitle: "添加员工",
    loading: false,
    pagination: {
        size: "large",
        current: 1,
        pageSize: 10,
        total: 10,
        pageSizeOptions: ["10", "20", "30"], //可选的页面显示条数
        showTotal: (total: string) => {
            console.log(total);
            return " 共" + total + "条";
        }, //展示每页第几条至第几条和总数
        hideOnSinglePage: false, // 只有一页时是否隐藏分页器
        showSizeChanger: true, //是否可以改变pageSize
    },
    searchMobile: "",
    searchName: "",
    staffType: "add",
    roleOption: [],
    //医生团队
    dentist_form_visible: false,
    dentistTeamId: "",
    dentistId: "",
    dentistOpType: "add",
    //设计团队
    designerTeamId: '',
    designerId: '',
    designerOpType: '',
    designer_form_visible: false,
    //工厂团队
    productTeamId: '',
    producerId: '',
    productOpType: '',
    product_form_visible: false,
    //医生审核
    dentist_detail_form_visible: false,
    dentist_review_common: '',
    doctorInfo: {
        id: '',
        born: '',
        email: "",
        name: "",
        gender: "",
        idNumber: "",
        mobile: "",
        level: '',
        license: '',
        docs: []
    },
    inputStatus: false
});

const route = useRoute();

const createPositionRef = ref();
const createStaffRef = ref();
const rules: Record<string, Rule[]> = {
    name: [
        {
            required: true,
            trigger: "change",
            validator: (_rule, value) => {
                if (!value) {
                    return Promise.reject("请输入姓名!");
                }
                if (value.length > 32 || value.length < 2) {
                    return Promise.reject("姓名长度应为2-8个字!");
                } else {
                    return Promise.resolve();
                }
            },
        },
    ],
    mobile: [
        {
            required: true,
            trigger: "change",
            validator: (_rule, value) => {
                if (!value) {
                    return Promise.reject("请输入手机号!");
                }
                if (!isMobile(value)) {
                    return Promise.reject("手机号格式错误!");
                } else {
                    return Promise.resolve();
                }
            },
        },
    ],
    idNumber: [
        {
            required: false,
            trigger: "change",
            validator: (_rule, value) => {
                if (!value) {
                    return Promise.resolve();
                }
                if (!cardid(value)) {
                    return Promise.reject("身份证格式错误!");
                } else {
                    return Promise.resolve();
                }
            },
        },
    ],
    email: [
        {
            required: false,
            trigger: "change",
            validator: (_rule, value) => {
                if (!value) {
                    return Promise.resolve();
                }
                if (!isEmail(value)) {
                    return Promise.reject("邮箱格式错误!");
                } else {
                    return Promise.resolve();
                }
            },
        },
    ],
    positionId: [
        {
            required: true,
            trigger: "change",
            validator: () => {
                if (!data.staffFormState.positionId) {
                    return Promise.reject("请选择员工职位!");
                } else {
                    return Promise.resolve();
                }
            },
        },
    ],
    roleIds: [
        {
            required: true,
            trigger: "change",
            validator: () => {
                if (!data.staffFormState.roleIds.length) {
                    return Promise.reject("请选择角色!");
                } else {
                    return Promise.resolve();
                }
            },
        }
    ]
};

// -----------------生命周期----------

onMounted(async () => {
    let type = route.query.type
    if (type === 'dentist_team') {
        data.dentistTeamId = route.query.id;
        console.log(data.dentistTeamId);
    } else if (type === 'designer_team') {
        data.designerTeamId = route.query.id;
        console.log(data.designerTeamId);
    } else if (type === 'product_team') {
        data.productTeamId = route.query.id;
        console.log(data.productTeamId);
    } else {
        data.partnerId = route.query.id;
        console.log(data.partnerId);
    }
    await init(route.query.id);
    await handleSearchRole('')
});

//-------------------方法-----------------
const init = (id: unknown) => {
    getPosition(id).then((res: never[]) => {
        console.log("获取职位", res);
        data.treeData = res;
        searchStaff();
    });
};


const searchStaff = () => {
    data.loading = true;
    let type = route.query.type
    const option = {
        page: {
            pageSize: data.pagination.pageSize,
            currPage: data.pagination.current,
        },
        positionId: data.selectedKey,
        keyword: data.searchName,
        mobile: data.searchMobile,
    };
    if (type === 'dentist_team') {
        //查询医生团队
        searchDentistMembers(option);
    } else if (type === 'designer_team') {
        //查询设计师团队
        searchDesignerMembers(option);
    } else if (type === 'product_team') {
        //查询生产团队
        searchProductMembers(option);
    } else {
        searchStaffWithPosition(option)
    }
};
const searchProductMembers = (option: any) => {
    option.teamId = data.productTeamId;
    pageMembersProducer(option).then((res: any) => {
        data.loading = false;
        if (res) {
            res.data.forEach((e: any) => {
                e.isLeader = e.teamLeader
            })
            data.dataSource = res.data;
            data.pagination.total = res.records;
        } else {
            data.dataSource = [];
            data.pagination.total = 0;
        }
    })
}
const searchDesignerMembers = (option: any) => {
    option.teamId = data.designerTeamId;
    pageMembersDesigner(option).then((res: any) => {
        data.loading = false;
        if (res) {
            res.data.forEach((e: any) => {
                e.isLeader = e.teamLeader
            })
            data.dataSource = res.data;
            data.pagination.total = res.records;
        } else {
            data.dataSource = [];
            data.pagination.total = 0;
        }
    })
}
const searchDentistMembers = (option: any) => {
    option.teamId = data.dentistTeamId;
    searchTeamMembers(option).then((res: any) => {
        data.loading = false;
        if (res) {
            data.dataSource = res.data;
            data.pagination.total = res.records;
        } else {
            data.dataSource = [];
            data.pagination.total = 0;
        }
    })
}
const searchStaffWithPosition = (option: any) => {
    option.partnerId = data.partnerId;
    searchPositionStaff(option).then((res: { data: never[], records: number }) => {
        data.loading = false;
        if (res) {
            data.dataSource = res.data;
            data.pagination.total = res.records;
        } else {
            data.dataSource = [];
            data.pagination.total = 0;
        }
    });
}
// 点击职位树节点
const onSelectTree = (selectedKeys: never) => {
    console.log("节点点击", selectedKeys[0]);
    data.selectedKey = selectedKeys[0];
    // treeValue.value = selectedKeys[0]
    data.staffFormState.positionId = selectedKeys[0];
    searchStaff();
};

const disabledDate = (current: Dayjs) => {
    // Can not select days before today and today
    return current && current > dayjs().endOf("day");
};

const handleTableChange = (ipagination: { pageSize: number, current: number }) => {
    data.pagination.pageSize = ipagination.pageSize;
    data.pagination.current = ipagination.current;
    searchStaff();
};

// ----------------职位-----------------

const handlePositionOk = () => {
    console.log(data.positionFormState.treeValue);
    let partnerId = 0;//data.partnerId ? data.partnerId : data.dentistTeamId;
    if (data.dentistTeamId) {
        partnerId = data.dentistTeamId;
    } else if (data.designerTeamId) {
        partnerId = data.designerTeamId;
    } else if (data.productTeamId) {
        partnerId = data.productTeamId;
    } else {
        partnerId = data.partnerId;
    }
    createPositionRef.value.validate().then(() => {
        let option = {
            ...data.positionFormState,
            parentId: data.positionFormState.treeValue,
            partnerId: partnerId,
        };
        console.log("关闭弹框", option);
        addPosition(option).then(() => {
            message.success("创建成功");
            data.positionVisible = false;
            init(partnerId);
            createPositionRef.value?.resetFields();
        });
    });
};

const nodeHandle = (info: any) => {
    console.log(info);
    data.positionVisible = true
    data.inputStatus = true
    data.staffFormState.positionId = info.partnerId
    nextTick(() => {
        data.positionFormState.name = info.name
        data.positionFormState.comment = info.comment
        data.positionFormState.id = info.id
        data.positionFormState.treeValue = info.parentId
    })
}

const handlePositionCancel = () => {
    createPositionRef.value?.resetFields();
}

const onOrganization = () => {
    data.positionVisible = true;
    data.positionFormState.treeValue = data.staffFormState.positionId;
    data.positionFormState.id = ''
    data.positionFormState.comment = ''
    data.inputStatus = false
};

// ------ 人员------------------

const onStaff = () => {
    if (data.dentistTeamId) {
        data.dentistOpType = "add"
        createDentist("")
    } else if (data.designerTeamId) {
        data.designerOpType = "add"
        createDesigner("")
    } else if (data.productTeamId) {
        data.productOpType = "add"
        createProducer("")
    } else {
        data.staffVisible = true;
    }
    data.staffType = "add";
    data.staffTitle = "添加人员";
    data.staffFormState.roleIds = []
};

const onEditStaff = (id: number) => {
    if (data.dentistTeamId) {
        data.dentistOpType = "update"
        createDentist(id)
    } else if (data.designerTeamId) {
        data.designerOpType = "update"
        createDesigner(id)
    } else if (data.productTeamId) {
        data.productOpType = "update"
        createProducer(id)
    } else {
        data.staffType = "update";
        data.staffTitle = "修改人员";
        data.staffVisible = true;
        getPositionStaff(id,route.query.id).then((res: any) => {
            console.log(res)
            data.staffFormState.id = res.id;
            for (const key in data.staffFormState.person) {
                data.staffFormState.person[key as keyof typeof data.staffFormState.person] = res[key];
            }
            data.avatarUrl = res.docs ? res.docs[0].path : "";
            data.staffFormState.deptLeader = res.deptLeader;
            data.staffFormState.positionId = res.positionId;
            data.staffFormState.roleIds = res.roleIds ? res.roleIds : [];
            data.staffFormState.person.born = res.born
                ? getDate(res.born)
                : "";
            data.staffFormState.person.gender = res.gender
                ? res.gender
                : "Male";
        });
    }
};
const handleStaffOk = () => {
    let option = {
        ...data.staffFormState.person,
        ...data.staffFormState,
        deptId: data.partnerId,
    };
    createStaffRef.value.validate().then(() => {
        console.log("校验成功");
        if (data.staffType == "add") {
            console.log("添加人员", option);
            option.docs = [
                {
                    id: null,
                    type: "AVATAR",
                    path: "",
                },
            ]
            option.docs[0].path = data.avatarUrl
            //防止将同一个员工绑定到多个user身上
            option.id = "";
            option.person.id = null;
            option.person.owner = "";
            addPositionStaff(option).then(() => {
                console.log("添加成功");
                data.avatarUrl = "";
                data.staffVisible = false;
                searchStaff();
                handleStaffCancel();
            });
        } else {
            if (option.docs) {
                option.docs[0].path = data.avatarUrl
            }
            updatePositionStaff(option).then(() => {
                data.staffVisible = false;
                searchStaff();
                handleStaffCancel();
            });
        }
    });
};

const handleStaffCancel = () => {
    data.staffFormState.deptLeader = false;
    createStaffRef.value.resetFields();
    data.avatarUrl = "";
};


/**
 * 审核医生
 * @param id
 */
const onReviewStaff = (id: string) => {
    getDentistInfo(id).then((res: any) => {
        data.dentist_detail_form_visible = true;
        data.dentist_review_common = ''
        console.log(res);
        data.doctorInfo = res
    })
}
const onReviewSubmit = (type: number) => {
    let option = {
        dentistId: data.doctorInfo.id,
        //2：代表驳回
        reviewStatus: 1,
        reviewCommon: data.dentist_review_common
    }
    if (type === 1) {
        option.reviewStatus = 2;
        reviewDentist(option).then(() => {
            message.success("审核成功")
            searchStaff()
        })
    } else {
        if (!data.dentist_review_common) {
            message.warning("请输入驳回的意见！");
            return
        }
        option.reviewStatus = 1;
        reviewDentist(option).then(() => {
            message.success("驳回成功")
            searchStaff()
        })
    }
    data.dentist_detail_form_visible = false
}
const resolveReviewCancel = () => {
    data.dentist_detail_form_visible = false
}

const onSuccess = (val: string) => {
    console.log("返回的路径", val);
    data.avatarUrl = val;
};

const confirm = (id: number) => {
    deletePositionStaff(id,route.query.id).then(() => {
        message.success("删除成功");
        searchStaff();
    });
};
let timeout: any;
let currentValue = "";
const handleSearchRole = (val: string) => {
    console.log("搜索角色");
    if (timeout) {
        clearTimeout(timeout);
        timeout = null;
    }
    currentValue = val;

    function fake() {
        let option = {
            page: {
                pageSize: 100,
                currPage: 1
            },
            keyword: val
        }
        searchSysRole(option).then((res: { data: never[] }) => {
            if (currentValue === val) {
                console.log('获取角色列表', res);
                if (res) {
                    data.roleOption = res.data
                } else {
                    data.roleOption = []
                }
            }
        })
    }

    timeout = setTimeout(fake, 300);
};

const handleChangeRole = () => {
    console.log("切换角色");
};

const createDentist = (id: any) => {
    data.dentistTeamId = route.query.id;
    data.dentistId = id
    console.log("打开医生新增/编辑", data.dentistTeamId)
    data.dentist_form_visible = true;
}
const createDesigner = (id: any) => {
    data.designerTeamId = route.query.id;
    data.designerId = id
    console.log("打开设计师新增/编辑", data.designerTeamId)
    data.designer_form_visible = true;
}
const createProducer = (id: any) => {
    data.productTeamId = route.query.id;
    data.producerId = id
    console.log("打开工厂新增/编辑", data.productTeamId)
    data.product_form_visible = true;
}
const hideForm = () => {
    if (data.dentistTeamId) {
        data.dentist_form_visible = false;
    } else if (data.designerTeamId) {
        data.designer_form_visible = false;
    } else if (data.productTeamId) {
        data.product_form_visible = false;
    }
};
const refDentistForm = ref()
const refDesignerForm = ref()
const refProducerForm = ref()
const submitForm = () => {
    if (data.dentistTeamId) {
        refDentistForm.value.onSubmit();
    } else if (data.designerTeamId) {
        refDesignerForm.value.onSubmit();
    } else if (data.productTeamId) {
        refProducerForm.value.onSubmit();
    }
}
const onCancel = () => {
    let type = route.query.type
    if (type === 'dentist_team') {
        data.dentist_form_visible = false;
    } else if (type === 'designer_team') {
        data.designer_form_visible = false;
    } else if (type === 'product_team') {
        data.product_form_visible = false;
    }
    searchStaff();
};
const resolvePositionName = (record: any) => {
    if (record.positionName) {
        return record.positionName;
    }else if (record.name) {
        return record.name;
    }
    return "";
};
const resolveReviewStatus = (record: any) => {
    if (record.reviewStatus === 'NOT_PASS') {
        return '审核未通过';
    } else if (record.reviewStatus === 'HAS_NONE') {
        return '待审核';
    } else {
        return '审核已通过'
    }
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_form_outlined = _resolveComponent("form-outlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 5 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: onOrganization
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                (data.treeData.length > 0)
                  ? (_openBlock(), _createBlock(_component_a_tree, {
                      key: 0,
                      style: {"overflow-x":"auto"},
                      "tree-data": data.treeData,
                      onSelect: onSelectTree,
                      defaultExpandAll: true,
                      fieldNames: fieldNames
                    }, {
                      title: _withCtx((record) => [
                        _createVNode(_component_a_space, { size: 10 }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(record.name), 1),
                            _createVNode(_component_form_outlined, {
                              onClick: ($event: any) => (nodeHandle(record))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["tree-data"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 19 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, { gutter: 16 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: data.searchName,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data.searchName) = $event)),
                          style: {"margin-bottom":"8px"},
                          placeholder: "根据名字搜索"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: data.searchMobile,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((data.searchMobile) = $event)),
                          style: {"margin-bottom":"8px"},
                          placeholder: "根据手机号搜索"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: searchStaff
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("搜索")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: onStaff
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("新增")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_table, {
                  dataSource: data.dataSource,
                  columns: data.columns,
                  bordered: "",
                  loading: data.loading,
                  pagination: data.pagination,
                  onChange: handleTableChange
                }, {
                  bodyCell: _withCtx(({ column, record }) => [
                    (column.dataIndex === 'name')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(record.name), 1))
                      : _createCommentVNode("", true),
                    (column.dataIndex === 'born')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(record.born ? _unref(getDate)(record.born) : ""), 1))
                      : _createCommentVNode("", true),
                    (column.dataIndex === 'gender')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(STATUS)("genderType").getDesc(record.gender)), 1))
                      : _createCommentVNode("", true),
                    (column.dataIndex === 'deptLeader' || column.dataIndex == 'teamLeader'|| column.dataIndex == 'isLeader')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(record.deptLeader || record.teamLeader || record.isLeader ? "是" : "否"), 1))
                      : _createCommentVNode("", true),
                    (column.dataIndex === 'position')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(resolvePositionName(record)), 1))
                      : _createCommentVNode("", true),
                    (column.dataIndex === 'reviewStatus' && record.reviewStatus)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(resolveReviewStatus(record)), 1))
                      : _createCommentVNode("", true),
                    (column.key === 'operation')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                          _createVNode(_component_a_button, {
                            type: "link",
                            onClick: ($event: any) => (onEditStaff(record.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("编辑")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          (record.reviewStatus && record.reviewStatus === 'HAS_NONE')
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "link",
                                onClick: ($event: any) => (onReviewStaff(record.id))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("审核")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (!_unref(route).query.type)
                            ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                key: 1,
                                title: "确认要删除该人员?",
                                "ok-text": "是",
                                "cancel-text": "否",
                                onConfirm: ($event: any) => (confirm(record.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, { type: "link" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("删除")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onConfirm"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["dataSource", "columns", "loading", "pagination"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (data.positionVisible)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          visible: data.positionVisible,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((data.positionVisible) = $event)),
          title: "添加/修改职位",
          onOk: handlePositionOk,
          onCancel: handlePositionCancel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              model: data.positionFormState,
              name: "basic",
              "label-col": { span: 6 },
              "wrapper-col": { span: 16 },
              autoComplete: "off",
              ref_key: "createPositionRef",
              ref: createPositionRef
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: "职位名称",
                  name: "name",
                  rules: [{ required: true, message: '请输入职位名称!' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: data.positionFormState.name,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((data.positionFormState.name) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "父级职位",
                  name: "treeValue",
                  rules: [
                    { required: data.treeData.length > 0, message: '请选择父级职位!' },
                ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tree_select, {
                      value: data.positionFormState.treeValue,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((data.positionFormState.treeValue) = $event)),
                      "show-search": "",
                      style: {"width":"100%"},
                      "dropdown-style": { maxHeight: '400px', overflow: 'auto' },
                      placeholder: "Please select",
                      "allow-clear": "",
                      "tree-default-expand-all": "",
                      "tree-data": data.treeData,
                      "field-names": {
                            children: 'children',
                            title: 'name',
                            value: 'id',
                        },
                      disabled: data.inputStatus
                    }, {
                      title: _withCtx(({ name }) => [
                        _createElementVNode("span", null, _toDisplayString(name), 1)
                      ]),
                      _: 1
                    }, 8, ["value", "tree-data", "disabled"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_a_form_item, { label: "职位描述" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      value: data.positionFormState.comment,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((data.positionFormState.comment) = $event)),
                      placeholder: "请输入职位描述",
                      rows: 4
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: data.staffVisible,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((data.staffVisible) = $event)),
      title: data.staffTitle,
      onOk: handleStaffOk,
      onCancel: handleStaffCancel
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: data.staffFormState.person,
          "label-col": { span: 6 },
          "wrapper-col": { span: 16 },
          autoComplete: "off",
          ref_key: "createStaffRef",
          ref: createStaffRef,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(UploadImage, {
                  onOnSuccess: onSuccess,
                  imageUrl: data.avatarUrl
                }, null, 8, ["imageUrl"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_a_form_item, {
                  label: "姓名",
                  name: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: data.staffFormState.person.name,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((data.staffFormState.person.name) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "生日",
                  name: "born"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_date_picker, {
                      value: data.staffFormState.person.born,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((data.staffFormState.person.born) = $event)),
                      "disabled-date": disabledDate,
                      valueFormat: "YYYY-MM-DD"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "性别" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio_group, {
                      value: data.staffFormState.person.gender,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((data.staffFormState.person.gender) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, { value: "Male" }, {
                          default: _withCtx(() => [
                            _createTextVNode("男")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio, { value: "Female" }, {
                          default: _withCtx(() => [
                            _createTextVNode("女")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_a_form_item, {
                label: "手机号",
                name: "mobile"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: data.staffFormState.person.mobile,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((data.staffFormState.person.mobile) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "身份证",
                name: "idNumber"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: data.staffFormState.person.idNumber,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((data.staffFormState.person.idNumber) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "邮箱",
                name: "email"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: data.staffFormState.person.email,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((data.staffFormState.person.email) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "职位",
                name: "positionId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tree_select, {
                    value: data.staffFormState.positionId,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((data.staffFormState.positionId) = $event)),
                    "show-search": "",
                    style: {"width":"100%"},
                    "dropdown-style": { maxHeight: '400px', overflow: 'auto' },
                    placeholder: "Please select",
                    "allow-clear": "",
                    "tree-default-expand-all": "",
                    "tree-data": data.treeData,
                    "field-names": {
                                children: 'children',
                                title: 'name',
                                value: 'id',
                            }
                  }, {
                    title: _withCtx(({ name }) => [
                      _createElementVNode("span", null, _toDisplayString(name), 1)
                    ]),
                    _: 1
                  }, 8, ["value", "tree-data"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "负责人" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_switch, {
                    checked: data.staffFormState.deptLeader,
                    "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((data.staffFormState.deptLeader) = $event))
                  }, null, 8, ["checked"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "角色",
                name: "roleIds"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: data.staffFormState.roleIds,
                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((data.staffFormState.roleIds) = $event)),
                    mode: "multiple",
                    "show-search": "",
                    placeholder: "请选择用户角色",
                    style: {"width":"200px"},
                    "default-active-first-option": false,
                    "show-arrow": false,
                    "filter-option": false,
                    "not-found-content": null,
                    options: data.roleOption,
                    onSearch: handleSearchRole,
                    onChange: handleChangeRole,
                    fieldNames: {
                                label: 'name',
                                value: 'id'
                            }
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_a_modal, {
      visible: data.dentist_form_visible,
      title: "医生",
      width: "40%",
      onCancel: hideForm,
      onOk: submitForm
    }, {
      default: _withCtx(() => [
        (data.dentist_form_visible)
          ? (_openBlock(), _createBlock(DentistForm, {
              key: 0,
              onOnCancel: onCancel,
              type: data.dentistOpType,
              id: data.dentistId,
              "team-id": data.dentistTeamId,
              ref_key: "refDentistForm",
              ref: refDentistForm
            }, null, 8, ["type", "id", "team-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: data.designer_form_visible,
      title: "设计师",
      width: "40%",
      onCancel: hideForm,
      onOk: submitForm
    }, {
      default: _withCtx(() => [
        (data.designer_form_visible)
          ? (_openBlock(), _createBlock(DesignerForm, {
              key: 0,
              onOnCancel: onCancel,
              type: data.designerOpType,
              id: data.designerId,
              "team-id": data.designerTeamId,
              ref_key: "refDesignerForm",
              ref: refDesignerForm
            }, null, 8, ["type", "id", "team-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: data.product_form_visible,
      title: "生产端",
      width: "40%",
      onCancel: hideForm,
      onOk: submitForm
    }, {
      default: _withCtx(() => [
        (data.product_form_visible)
          ? (_openBlock(), _createBlock(ProductForm, {
              key: 0,
              onOnCancel: onCancel,
              type: data.productOpType,
              id: data.producerId,
              "team-id": data.productTeamId,
              ref_key: "refProducerForm",
              ref: refProducerForm
            }, null, 8, ["type", "id", "team-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: data.dentist_detail_form_visible,
      title: "医生审核",
      width: "60%",
      onCancel: resolveReviewCancel
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_textarea, {
              value: data.dentist_review_common,
              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((data.dentist_review_common) = $event)),
              placeholder: "审核不通过时输入意见"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (onReviewSubmit(1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("审核通过")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "danger",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (onReviewSubmit(0)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("驳回申请")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(DoctorView, {
          doctorInfo: data.doctorInfo
        }, null, 8, ["doctorInfo"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})